


const FetchRegressionData = (data, selectedSeason, selectedX, selectedY) => {

    return(
        
        new Promise((resolve, reject) => {

            var x_array = []
            var y_array = []
        
            data.allTeamsCsv.nodes.forEach((node) => {
                if (parseInt(node['season']) === selectedSeason['value']) {
                    x_array.push(Math.round(10000*node[selectedX['value']])/10000)
                    y_array.push(Math.round(10000*node[selectedY['value']])/10000)
                }
            })     
            
            resolve(
                [
                    x_array,
                    y_array
                ]
            )
        })
    
    )

}

export default FetchRegressionData


